// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__P5Qua","active":"NavigationItem_active__3tbM6"};